import React from 'react'

const Hamburger = () => {
    return (
        <svg fill="var(--primary)" width="40px" height="40px" viewBox="0 0 1920 1920">
            <path d="M1920 1411.412v225.882H0v-225.882h1920Zm0-564.706v225.882H0V846.706h1920ZM1920 282v225.882H0V282h1920Z" fillRule="evenodd"/>
        </svg>
    )
}

export default Hamburger